import { UseToastProps } from '@eqi-investimentos/react';

export const toastConfigDefault = {
  primary: {
    showIcon: false,
    variant: 'success',
    position: 'top',
  } as UseToastProps,
};
